// birth 19960101 또는 960101
export const birthToYYMD = (birth: string | undefined) => {
  if (!birth) {
    return '';
  }
  if (birth.length === 6) {
    const year = birth.slice(0, 2);
    const month = birth.slice(2, 4);
    const day = birth.slice(-2);
    return `${year}년 ${Number(month)}월 ${Number(day)}일생`;
  }
  if (birth.length === 8) {
    const year = birth.slice(2, 4);
    const month = birth.slice(4, 6);
    const day = birth.slice(-2);
    return `${year}년 ${Number(month)}월 ${Number(day)}일생`;
  }

  return birth;
};

// input-19920101 output-1992.01.01
export const toggleBirthdayDot = (birthday: string | undefined) => {
  if (!birthday) {
    return '';
  }
  if (birthday.length === 6) {
    return `${birthday.slice(0, 2)}.${birthday.slice(2, 4)}.${birthday.slice(-2)}`;
  }
  return birthday.replace(/\./g, '');
};
